<script setup lang="ts">
import { computed, ref } from "vue"

const showBanner = ref(true)

function closeBanner() {
  showBanner.value = false
}

const maintenanceDate = new Date("2024-12-16")
const today = new Date()
const shouldShowBanner = computed(() => {
  return today <= maintenanceDate
})
</script>

<template>
  <div
    v-if="showBanner && shouldShowBanner"
    class="absolute top-12 z-50 mx-4 rounded-lg bg-dark-blue-dark p-6 text-center font-national2 shadow-lg md:right-8 md:w-1/4"
  >
    <div class="flex items-start justify-between gap-4">
      <div class="flex items-center gap-4">
        <p class="text-left text-lg text-white">
          <span class="font-bold">Mandag 16. desember </span>vil Kunne
          være utilgjengelig i en kort periode på grunn av
          vedlikehold.
        </p>
      </div>
      <button
        class="rounded-full p-1.5 hover:bg-dark-blue-darker"
        aria-label="Lukk vedlikeholdsvarsel"
        @click="closeBanner"
      >
        <UIcon
          name="close"
          size="sm"
          class="text-white"
        />
      </button>
    </div>
  </div>
</template>
